"use client";

import type { Locale } from "@/config/i18n";
import { EXCURSION_UI } from "./excursionUi";
import { tr } from "@/config/localeText";

type Item = { label: string; value: string };

type Props = {
  title: string;
  items: Item[];
  locale?: Locale;
};

const PracticalInfoSection = ({
  title,
  items,
  locale = "fr",
}: Props): JSX.Element => {
  const ui = tr(EXCURSION_UI, locale);
  return (
    <section className="relative bg-white py-16 text-black">
      <div className="relative mx-auto max-w-[90rem] px-6 md:px-8">
        <h2 className="mb-2 font-space-age text-lg tracking-[0.2em]">
          {title}
        </h2>
        <p className="mb-8 max-w-3xl text-sm text-black/70">
          {ui.practicalIntro}
        </p>
        <dl className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {items.map((it, idx) => (
            <div
              key={idx}
              className="rounded-2xl border border-black/10 bg-black/[0.02] p-6"
            >
              <dt className="text-xs uppercase tracking-[0.18em] text-black/60">
                {it.label}
              </dt>
              <dd className="mt-1 text-sm text-black/85">{it.value}</dd>
            </div>
          ))}
        </dl>
      </div>
    </section>
  );
};

export default PracticalInfoSection;
